import {Routes} from '@angular/router';

import {SuccessComponent} from './utilities/component/success/success.component';
import {UnauthorisedComponent} from './utilities/component/no-access/unauthorised.component';
import {ErrorComponent} from './utilities/component/error/error.component';
import {AuthGuard} from '@auth0/auth0-angular';

export const routes: Routes = [

  { path: '', component: UnauthorisedComponent },
  { path: 'annual-review-questionnaire',
    loadComponent: () => import('./features/annual-review/component/annual-review-questionnaire/annual-review-questionnaire.component').then(c => c.AnnualReviewQuestionnaireComponent),
    canActivate: [AuthGuard],
    title: 'Annual review'
  },
  { path: 'success', component: SuccessComponent, canActivate: [AuthGuard]},
  { path: 'no-access', component: UnauthorisedComponent, title: 'Unauthorised' },
  { path: 'error', component: ErrorComponent, title: 'Error' },
  { path: '**', component: UnauthorisedComponent },
];
